import {
  bg0,
  bg1,
  bg2,
  bg3,
  bg4,
  bg5,
  bgBlue,
  bgBlueLight,
  bgEmerald,
  bgGreen,
  bgGreenLight,
  bgLavender,
  bgLavenderLight,
  bgLightestBlue,
  bgNegative,
  bgNegativeLight,
  bgNegativeLightest,
  bgOlive,
  bgOliveLight,
  bgOrange,
  bgOrangeLight,
  bgPink,
  bgPinkLight,
  bgPositive,
  bgPositiveLight,
  bgPrimary,
  bgPrimaryLight,
  bgPrimaryLightest,
  bgPrimaryText,
  bgPurple,
  bgPurpleLight,
  bgRed,
  bgRedLight,
  bgTeal,
  bgTealLight,
  bgWarning,
  bgWarningLight,
  bgYellow,
  bgYellowLight,
} from './background';
import {
  textBlue,
  textGreen,
  textLavender,
  textOlive,
  textOrange,
  textPink,
  textPurple,
  textRed,
  textTeal,
  textYellow,
  textPositiveText,
  textWarningText,
  textNegativeText,
  text5,
  text0,
  text1,
  text2,
  text3,
  text4,
} from './text';

export const REBASS_TO_TAILWIND_TEXT_MAP = {
  blueText: textBlue,
  yellowText: textYellow,
  tealText: textTeal,
  oliveText: textOlive,
  greenText: textGreen,
  green: textGreen,
  orangeText: textOrange,
  redText: textRed,
  pinkText: textPink,
  lavenderText: textLavender,
  purpleText: textPurple,
  text: text5,
  textInvert: text0,
  negativeText: textNegativeText,
  negative: textNegativeText,

  gray5: text0,
  gray10: text1,
  gray15: text1,
  gray20: text1,
  gray30: text2,
  gray40: text3,
  gray50: text3,
  gray60: text4,
  gray70: text4,
  gray80: text4,
};

// DO NOT USE THIS, ONLY FOR COLOR COMPARISONS
export const REBASS_TO_TAILWIND_BG_MAP: Record<string, string> = {
  dark: bg4,
  white: 'bg-white',
  'bg-0': bg0,
  'bg-1': bg1,
  'bg-2': bg1,
  'bg-3': bg2,
  'bg-4': bg2,
  gray5: bg1,
  gray10: bg1,
  gray15: bg1,
  gray20: bg2,
  gray30: bg3,
  gray40: bg3,
  gray50: bg4,
  gray60: bg4,
  gray70: bg4,
  gray80: bg5,
  gray90: bg5,
  primary: bgPrimary,
  primaryLight: bgPrimaryLight,
  primaryLightest: bgPrimaryLightest,
  primaryText: bgPrimaryText,
  lightestBlue: bgLightestBlue,
  negative: bgNegative,
  negativeLight: bgNegativeLight,
  negativeLightest: bgNegativeLightest,
  negativeText: textNegativeText,
  warning: bgWarning,
  warningLight: bgWarningLight,
  warningText: textWarningText,
  positive: bgPositive,
  positiveLight: bgPositiveLight,
  positiveText: textPositiveText,
  blue: bgBlue,
  yellow: bgYellow,
  teal: bgTeal,
  olive: bgOlive,
  green: bgGreen,
  orange: bgOrange,
  red: bgRed,
  pink: bgPink,
  lavender: bgLavender,
  purple: bgPurple,
  clinicalGroupBg: 'bg-clinical-group-bg-500',
  clinicalGroupText: 'bg-clinical-group-text-500',
  baseGroupText: 'bg-green-800',
  basicGroupBg: 'bg-green-100',
  blueLight: bgBlueLight,
  yellowLight: bgYellowLight,
  tealLight: bgTealLight,
  oliveLight: bgOliveLight,
  greenLight: bgGreenLight,
  emerald: bgEmerald,
  orangeLight: bgOrangeLight,
  redLight: bgRedLight,
  pinkLight: bgPinkLight,
  lavenderLight: bgLavenderLight,
  purpleLight: bgPurpleLight,
  clinicalGroupTextLight: 'bg-clinical-group-bg-500/[.25]',
  clinicalGroupBgLight: 'bg-clinical-group-text-500/[.25]',
  basicGroupTextLight: 'bg-green-800/[.25]',
  basicGroupBgLight: 'bg-green-100/[.25]',
  black: bg5,
};
